// src/store/auth.js
import { defineStore } from "pinia";
import api from "../services/api";
import { useUiStore } from "./ui";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: null,
    races: [],
    isInitialized: false,
  }),
  actions: {
    setUser(userData) {
      this.user = userData;
      this.isInitialized = true;
    },

    async fetchUser() {
      if (this.isInitialized) return;
      try {
        const response = await api.get("/api/user");
        this.user = response.data.user;
      } catch (error) {
        this.user = null;
        console.error("No user session found:", error.response?.data?.error);
      } finally {
        this.isInitialized = true;
      }
    },

    async register(credentials) {
      return api.post("/auth/register", credentials, { timeout: 20000 });
    },

    async login(credentials) {
      const response = await api.post("/auth/login", credentials, {
        timeout: 20000,
      });
      this.setUser(response.data.user);
    },

    async logout() {
      const { useChatStore } = await import("./chatStore");
      useChatStore().disconnect();
      await api.get("/logout");
      this.user = null;
      this.races = [];
      this.isInitialized = false;
      // Clear the session flag so the intro can play on the next login.
      sessionStorage.removeItem("hasPlayedIntro");
    },

    async fetchRaces() {
      try {
        const response = await api.get("/api/game/races");
        this.races = response.data;
      } catch (error) {
        console.error("Error fetching races:", error);
      }
    },

    async selectRace(raceSlug) {
      try {
        const response = await api.post(
          "/api/user/select-race",
          {
            race: raceSlug,
          },
          { timeout: 20000 }
        );
        this.user = response.data.user;
        return response.data;
      } catch (error) {
        console.error("Error selecting race:", error);
        throw error;
      }
    },

    // --- NEW ACTION ---
    async setNickname(nickname, avatarId) {
      try {
        const response = await api.post("/api/user/set-nickname", {
          nickname,
          avatar_id: avatarId,
        });
        this.setUser(response.data.user);
        return response.data;
      } catch (error) {
        console.error("Error setting nickname:", error);
        throw error;
      }
    },
  },
});
